const parseIntWithOverflow = function(str)
{
    var x = parseInt(str);
    const maxUInt32 = Math.pow(2,32);
    const treshold = maxUInt32/2;
    if(x > treshold)
        x = - (maxUInt32 - x);
    return x;
};


export const calculator = {
    parseIntWithOverflow,
}